<template>
  <article id="article-gold" sticky-container>
    <ul class="toggle-nav">
      <li :class="[$route.name == 'miniapp-market-gold-trader' ?  'active' : '']">
        <a href="javascript:;" data-action="open_tab" data-tab="gold_trader" @click="bindRoute('miniapp-market-gold-trader')">ราคาทองคำไทย</a>
      </li>
      <li :class="[$route.name == 'miniapp-market-gold-spot' ?  'active' : '']">
        <a href="javascript:;" data-action="open_tab" data-tab="gold_spot"  @click="bindRoute('miniapp-market-gold-spot')">ราคาทองคำโลก</a>
      </li>
    </ul>
    <router-view />
    <div id="goldtrader-container">
      <h2>ราคาทองคำจากสมาคมค้าทองคำ</h2>
      <div
        class="update-time"
      >อัพเดต: {{ formatThaiDate(goldTraderPresent.createdAt) }} | เวลา {{ formatTime(goldTraderPresent.createdAt) }} | ครั้งที่ {{ goldTraderPresent.createdTime}}</div>
      <GoldCard
        type="association"
        goldType="trader_bar"
        goldTitle="ทองคำแท่ง 96.5%"
        modalTitle="ราคาทองคำแท่ง 96.5"
        data-assetname="bar"
        :change="goldTraderPresent.barPriceChange"
        :bid="goldTraderPresent.barBuyPrice"
        :ask="goldTraderPresent.barSellPrice"
        :currentDate="formatThaiDate(goldTraderPresent.createdAt)"
        :currentRound="goldTraderPresent.createdTime"
        :currentTime="formatTime(goldTraderPresent.createdAt)"
        :queryDate="queryDate"
      />
      <GoldCard
        data-assetname="ornament"
        type="association"
        goldType="trader_ornament"
        goldTitle="ทองรูปพรรณ 96.5%"
        modalTitle="ราคาทองรูปพรรณ 96.5"
        :bid="goldTraderPresent.ornamentBuyPrice"
        :ask="goldTraderPresent.ornamentSellPrice"
        :currentDate="formatThaiDate(goldTraderPresent.createdAt)"
        :currentRound="goldTraderPresent.createdTime"
        :currentTime="formatTime(goldTraderPresent.createdAt)"
        :queryDate="queryDate"
      />
    </div>

    <div id="goldglobal-container">
      <h2>ราคาทองอ้างอิงตลาดต่างประเทศ</h2>
      <div class="update-time">อัพเดต: {{ goldSpotTime }}</div>
      <GoldCard
        type="global"
        goldTitle="Gold Spot"
        goldType="gold_spot"
        data-assetname="spot"
        :change="calGoldSpotPercentChange"
        :bid="getGoldSpotPreviousClose.o"
        :ask="getGoldSpotPreviousClose.c"
        modalTitle="Gold Spot"
      />
      <!-- <GoldCard type="global" goldTitle="Gold Future" change="-2.1" bid="1493.00" ask="1494.75" /> -->
    </div>

    <!-- gold releted Article -->
    <section id="section-gold-article">
      <GoldArticle />
    </section>
    <section id="section-gold-fund">
      <GoldFund />
    </section>
  </article>
</template>


<script>
import moment from "moment"
import { mapGetters, mapActions } from "vuex"
import { timestampToDate, calPercentChange } from "../../../../utils/global"

export default {
  components: {
    GoldArticle: () => import("../../../../components/miniapp/market/GoldArticle"),
    GoldCard: () => import("../../../../components/miniapp/market/GoldCard"),
    GoldFund: () => import("../../../../components/miniapp/market/GoldFund")
  },
  data() {
    return {
      goldTraderPresent: {},
      queryDate: ""
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.name == "miniapp-market-gold") {
          this.$router.push({
            name: this.getMarketActiveTabChild,
            query: route.query
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters("global", ["getMarketActiveTabChild"]),
    ...mapGetters("gold", ["getGoldSpotLastQuote", "getGoldSpotPreviousClose"]),
    goldSpotTime() {
      return timestampToDate(this.getGoldSpotPreviousClose.t, "lll")
    },
    calGoldSpotPercentChange() {
      return calPercentChange(this.getGoldSpotPreviousClose.o, this.getGoldSpotPreviousClose.c, 3)
    }
  },
  async created() {
    this.goldTraderPresent = await this.findGoldTraderPresent()
    this.queryDate = this.getCurrentDate(this.goldTraderPresent.createdAt)

    window.addEventListener("scroll", this.handleScroll)
    window.scroll(0, 0)
  },
  async mounted() {
    await this.fetchGlobalConfiguration("line-liff/config/goldgraph.json")
    await this.findGoldSpotPreviousClose()
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    ...mapActions("global", ["saveMarketActiveTabChild"]),
    ...mapActions("gold", [
      "findGoldTraderPresent",
      "findGoldTraderHistory",
      "findGoldSpotPreviousClose",
      "fetchGlobalConfiguration"
    ]),
    handleScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      currentScrollPosition > 73 ? (this.shouldStick = true) : (this.shouldStick = false)
      this.$emit("current-scroll", currentScrollPosition)
    },
    toggleFilter() {
      if (this.isFilter) {
        this.isFilter = false
      } else {
        this.isFilter = true
      }
    },
    formatThaiDateWithWeekDay(date) {
      let momentDate = moment(date).locale("th-TH")
      return momentDate.format("ddddที่ DD/MM/") + momentDate.add("543", "years").format("YYYY")
    },
    formatThaiDate(date) {
      let momentDate = moment(date).locale("th-TH")
      return momentDate.format("DD MMM") + momentDate.add("543", "years").format(" YYYY")
    },
    formatTime(date) {
      return moment.utc(date).format("HH.mm")
    },
    getCurrentDate(e) {
      return moment(e).format("YYYY-MM-DD")
    },
    bindRoute(routeName) {
      this.$router.push({ name: routeName })
      this.saveMarketActiveTabChild(routeName)
    }
  }
}
</script>

<style lang="scss" scoped>
#article-gold {
  @extend %container-style;
  padding: 24px 16px;
  position: relative;
  background-color: #fdfdfd;
  .toggle-nav {
    border-radius: 20px;
    background-color: #efefef;
    list-style: none;
    padding: 3px;
    display: block;
    max-width: 286px;
    width: 100%;
    margin: 0 auto;
    li {
      text-align: center;
      @include finCol(6, 12, 0px, middle, true, true);
    }
    a {
      color: $color-normal-text;
      text-decoration: none;
    }
    .active {
      padding: 0;
      border-radius: 20px;
      background-color: $color-normal-text;
      a {
        color: $color-white;
        font-weight: bold;
      }
    }
  }
  .top-sticky {
    left: 0 !important;
    width: 100% !important;
    .select-period-row {
      padding-top: 49px;
    }
  }

  #goldtrader-container {
    margin-top: 24px;
    color: $color-normal-text;

    h2 {
      @extend %font-size-m;
    }

    .update-time {
      font-family: DBHeaventRez;
      @extend %font-size-ss;
      color: $color-secondary;
      padding-bottom: 8px;
    }
  }

  #goldglobal-container {
    color: $color-normal-text;

    h2 {
      margin-top: 40px;
      @extend %font-size-m;
    }

    .update-time {
      font-family: DBHeaventRez;
      @extend %font-size-ss;
      color: $color-secondary;
      padding-bottom: 16px;
    }
  }

  #section-other-article {
    padding-bottom: 24px;
  }
}
</style>